"use client"

import { OfferLayout } from "@/components/offer/OfferLayout";
import { PaymentComponent } from "@/components/PaymentComponent";
import { VGSPaymentComponent } from "@/components/VGSPaymentComponent";
import { OdiePaymentComponent } from "@/components/OdiePaymentComponent";
import { useOfferContext } from "@/lib/hooks/useOfferContext";
import { datadogRum } from '@datadog/browser-rum';

export default function OfferPage() { 
  const { config, acceptedQuotes, findFirstQuote } = useOfferContext();

  datadogRum.setViewName('v1');

  // Check if it's a pet product and find the accepted quote
  const isPetProduct = config?.product_config?.hasOwnProperty('pet');
  const acceptedQuote = isPetProduct && acceptedQuotes?.length === 1 ? findFirstQuote() : null;
  const isOdieCarrier = acceptedQuote?.product?.carrier_name === 'Odie';

  return (
    <>
      <OfferLayout />
      {config?.payments?.enabled && acceptedQuotes?.length > 0 && (
        isPetProduct ? (
          isOdieCarrier ? (
            <OdiePaymentComponent />
          ) : (
            <VGSPaymentComponent />
          )
        ) : (
          <PaymentComponent />
        )
      )}
    </>
  );
}